export const YOO_FINDS_H5_CDN_URL = `https://cdn-01.yolobuyer.com`;
